import { hamburgerMenu } from "./modules/hamburgerMenu";
import { lottieAnimation } from "./modules/lottieAnimation";
import { fixedHeader } from "./modules/fixedHeader";
import { projectModal } from "./modules/projectModal";
import { aboutSlider } from "./modules/aboutSlider";
import { faqCard } from "./modules/faqCard";
import { anchorScroll } from "./modules/anchorScroll";
import { inview } from "./modules/inview";
import { privacyPolicy } from "./modules/privacyPolicy";
import { archiveInview } from "./modules/archiveInview";

document.addEventListener("DOMContentLoaded", () => {
  hamburgerMenu();
  lottieAnimation();
  fixedHeader();
  projectModal();
  aboutSlider();
  faqCard();
  anchorScroll();
  privacyPolicy();
  archiveInview();

  const rootMargin = window.matchMedia("(max-width: 767px)").matches ? "-10% 0px -10% 0px" : "-10% 0px -20% 0px";

  inview(".inview", {
    rootMargin: rootMargin,
  });
});
